// This file will be the single source of truth for your navigation.
// We'll add a subtitle to each item for a more dynamic welcome message.

export const navItems = [
  {
    id: "ai-matchmaking",
    path: "/dashboard/ai-matchmaking",
    icon: "ai",
    label: "Career Path Mapping",
    subtitle: "Let's find the career path for you.",
  },
  {
    id: "resume-builder",
    path: "/dashboard/resume-builder",
    icon: "resume",
    label: "Resume Builder",
    subtitle: "Create or edit your master resume.",
  },
  {
    id: "job-listing",
    path: "/dashboard/job-listing",
    icon: "job",
    label: "Job Listing",
    subtitle: "Find jobs and optimize your resume for them.",
  },
  {
    id: "resume-optimization",
    path: "/dashboard/resume-optimization",
    icon: "optimization",
    label: "Resume Optimization",
    subtitle: "Tailor your resume and generate a cover letter.",
  },
  {
    id: "cover-letter",
    path: "/dashboard/cover-letter",
    icon: "job", // Using 'job' icon, or create a new one for 'letter'
    label: "Cover Letter Generator",
    subtitle: "Create a cover letter based on your optimized resume.",
  },
  {
    id: "profile",
    path: "/profile-setup",
    icon: "profile",
    label: "Profile Management",
    subtitle: "Manage your account and settings.",
  },
];
